import React, { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import Parser from "html-react-parser";
import { isEmpty } from "lodash";
import BasicBanner from "@components/BasicBanner/BasicBanner";
import Meta from "@components/Meta/Meta";
import Pagination from "@components/Pagination/Pagination";
import useMediaQuery from "app/hooks/useMediaQuery";
import * as CMSActionsAhorro from "../../store/actions";

import "./Promociones.css";

const ROOT = process.env.REACT_APP_CMS_STATIC;
const PAGE_SIZE = 4;

const Promociones = () => {
  const dispatch = useDispatch();
  const [banner, setBanner] = useState({});
  const [promos, setPromos] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const filteredPromos = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PAGE_SIZE;
    const lastPageIndex = firstPageIndex + PAGE_SIZE;
    return promos?.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, promos]);

  const isDesktop = useMediaQuery("(min-width: 992px)");
  const isIpadPortrait = useMediaQuery("(max-width: 992px)");
  const isIphoneLandscape = useMediaQuery("(max-width: 576px)");

  //Selectores de estado
  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);
  const { loggedUser } = useSelector(({ Base }) => Base?.User);
  const { promociones } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  const defRoute = rutas?.filter((route) => route?.name === "Promociones");

  useEffect(() => {
    const { token } = loggedUser;
    if (token) {
      dispatch(CMSActionsAhorro.getPromociones(token));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedUser]);

  useEffect(() => {
    !isEmpty(promociones) &&
      setPromos(promociones?.aCPromociones[0]?.promociones?.contentItems);
  }, [promociones]);

  useEffect(() => {
    if (
      promociones &&
      promociones.bannerPromociones &&
      promociones.bannerPromociones.length > 0
    ) {
      let backgroundImage, mainImage;

      mainImage = promociones.bannerPromociones[0].imagenPrincipal &&
        promociones.bannerPromociones[0].imagenPrincipal.urls[0] && {
          img: ROOT + promociones.bannerPromociones[0].imagenPrincipal.urls[0],
          alt: "Promociones",
        };
      let title = promociones.bannerPromociones[0].displayText;
      let description = promociones.bannerPromociones[0].copyText?.html;

      if (isIphoneLandscape) {
        backgroundImage =
          ROOT + promociones.bannerPromociones[0].imagendeFondoMovil.urls[0];
      } else if (isIpadPortrait) {
        backgroundImage =
          ROOT + promociones.bannerPromociones[0].imagendeFondoIPad.urls[0];
      } else if (isDesktop) {
        backgroundImage =
          ROOT + promociones.bannerPromociones[0].imagendeFondo.urls[0];
      }
      setBanner({
        backgroundImage: {
          img: backgroundImage,
          alt: "Banner de Promociones",
        },
        mainImage: mainImage,
        title: title,
        description: description,
      });
    }
  }, [promociones, isIphoneLandscape, isIpadPortrait, isDesktop]);

  return (
    <>
      <Meta
        title={defRoute[0]?.title}
        description={defRoute[0]?.description}
        canonicalUrl={defRoute[0]?.url}
      />

      <div className="main-content promo-container">
        <BasicBanner
          backgroundImage={banner.backgroundImage}
          mainImage={banner.mainImage}
          title={banner.title}
          description={banner.description}
        />
        {
          <div className="promos-list">
            {!isEmpty(filteredPromos) ? (
              <>
                <div className="d-flex flex-wrap">
                  {filteredPromos.map((promo, index) => (
                    <div key={index} className="promo-item">
                      <div className="promo-card">
                        {promo && promo.tituloPromocion.html && (
                          <div className="promo-title">
                            {Parser(promo.tituloPromocion.html)}
                          </div>
                        )}
                        <div className="promo-body">
                          {promo && (
                            <>
                              <div className="promo-image">
                                <img
                                  src={ROOT + promo?.imagenPromocion?.urls[0]}
                                  alt={promo?.displayText}
                                />
                              </div>
                              {promo.slogan.html && (
                                <div className="promo-slogan">
                                  {Parser(promo.slogan.html)}
                                </div>
                              )}
                              {promo.promocion.html && (
                                <div className="anchor-row-promos">
                                  {Parser(promo.promocion.html)}
                                </div>
                              )}
                              {promo.descripcion.html && (
                                <div className="promo-slogan">
                                  {Parser(promo.descripcion.html)}
                                </div>
                              )}
                              {promo.nota.html && (
                                <div className="promo-nota mt-3">
                                  {Parser(promo.nota.html)}
                                </div>
                              )}
                            </>
                          )}
                        </div>
                        {promo && promo.uRLImagenBoton.url && (
                          <div className="promo-button-container">
                            <a
                              href={promo.uRLImagenBoton.url}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <img
                                src={ROOT + promo.imagenBoton.urls[0]}
                                alt={promo.displayText}
                              />
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                <Pagination
                  className="pagination-bar"
                  currentPage={currentPage}
                  totalCount={promos.length}
                  pageSize={PAGE_SIZE}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </>
            ) : (
              <div className="promo-title">
                No se han encontrado promociones.
              </div>
            )}
          </div>
        }
      </div>
    </>
  );
};

export default Promociones;
